<template>
  <main class="mini-page">
    <!-- 作者信息 -->
    <section class="user-info">
      <dl>
        <dt>
          <img :src="pageUrlObj.pic" alt="">
        </dt>
        <dd>
          <span class="name">{{pageUrlObj.name}}</span>
          <span class="before-time">{{worksDetail.createTime}}</span>
        </dd>
      </dl>
    </section>
    <!-- 内容 -->
    <article class="works-detail">
      <div class="works-name">
        <span>作品名称：</span>
        <h3>{{worksDetail.title}}</h3>
      </div>
      <div class="works-introduction" v-if="worksDetail.introduce">
        <strong>作品介绍：</strong>
        <p>{{worksDetail.introduce}}</p>
      </div>
      <div class="works-OI" v-if="worksDetail.explain">
        <strong>操作说明：</strong>
        <p>{{worksDetail.explain}}</p>
      </div>
      <div class="works-window">
        <div class="title" v-if="worksDetail.codes && pageUrlObj.type!=='3'">
          <img src="https://wugecdn.steam.fun/resources/static/jiaxiaotong/课堂作品.png" alt="Icon" />
          <strong class="title-name">{{worksTypeEnum[pageUrlObj.type]}}</strong>
          <el-tag size="small" v-for="codeItem in worksDetail.codeArr" :key="codeItem.id" :effect="worksDetail.codes.id === codeItem.id ? 'dark':''" @click="handleChangeCodeItem(codeItem.id)">{{codeItem.label}}</el-tag>
        </div>
        <!-- 引入iframe -->
        <div :class="{'iframe-box':true, 'show-tools': iframeShowTools}">
          <!-- Jrcode -->
          <iframe v-if="pageUrlObj.subjectCode === '1'" style="border: 0" frameborder="0" scrolling="no" :src="'/jrcode/h5show1.html?mode=look&filepath=' + worksDetail.workUrl" width="100%" height="100%" id="bdIframe"></iframe>
          <!-- Scratch -->
          <!-- 如果要特别控制iframe内的宽度，需要传入以下URL参数：scoure=MiniWorksDetails&basePageWidth=750&marginVal=80 -->
          <iframe v-if="pageUrlObj.subjectCode === '2'" style=" border: 0; " :src="'/scratch/h5player1.html?scoure=MiniWorksDetails&basePageWidth=750&marginVal=80&work_type=2' +
          '&work_id=' +
          worksDetail.id +
          '&subject_code=' +
          '2' +
          '&tchWorkInfo=' +
          JSON.stringify(this.worksDetail)
          " frameborder="0" scrolling="no" width="100%" height="100%" id="bdIframe"></iframe>
          <!-- Python -->
          <div class="code-box" v-if="pageUrlObj.subjectCode === '3'">
            <codemirror v-for="codeItem in worksDetail.codeArr" :key="codeItem.id" :style="{width: '100%', height: '100%',borderRadius: '10px'}" ref="cmEditor" :value="worksDetail.codes.code" :options="cmOptions" />
          </div>
          <!-- C++ -->
          <div class="code-box" v-if="pageUrlObj.subjectCode === '4'">
            <codemirror v-for="codeItem in worksDetail.codeArr" :key="codeItem.id" :style="{width: '100%', height: '100%',borderRadius: '10px'}" ref="cmEditor" :value="worksDetail.codes.code" :options="cmOptions" />
          </div>
        </div>
      </div>
      <div class="leave" v-if="worksDetail.leave">
        <strong>作品等级</strong>
        <el-rate v-model="worksDetail.leave" :max="5" disabled></el-rate>
      </div>
      <div class="remark" v-if="worksDetail.remark">
        <strong>评语</strong>
        <p>{{worksDetail.remark}}</p>
      </div>
    </article>
  </main>
</template>
<script>
//引入codemirror
import { codemirror } from "vue-codemirror";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/idea.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！
import "codemirror/theme/neo.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！
import "codemirror/theme/dracula.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！

import "codemirror/theme/idea.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！

require("codemirror/mode/python/python"); // 这里引入的模式的js，根据设置的mode引入，一定要引入！！
import "codemirror/theme/base16-dark.css";

import { getUrlArg } from '@/utils/utils'

import { api_selectTchWorkDetail, api_selectCppWorkDetail, api_selectWorkDetail, api_selectH5 } from '@/api/webViewApi'

export default {
  components: {
    codemirror,
  },
  data: () => ({
    pageUrlObj: {}, // url带来的参数
    cmOptions: { // c++和py容器的配置项
      tabSize: 4,
      mode: "python",
      //theme: "mdn-like",
      theme: "idea",
      lineNumbers: true,
      line: true,
      matchBrackets: true,
      autoCloseBrackets: true, // 自动闭合符号
      styleActiveLine: true, // 显示选中行的样式
    },
    // 详情信息
    worksDetail: {
      id: '', // id
      createTime: '', // 时间
      title: '', // 作品名称
      introduce: '', // 介绍
      explain: '',// 操作说明
      iframeUrl: '', // iframe地址
      leave: '', // 作品等级
      remark: '', // 评语
      cppWorkDetailVoList: [], // c++题目组
      workUrl: '',
      work_url: '',
      covers: '',
      codes: {},
      codeArr: []
    },
    worksTypeEnum: {
      1: '课堂作品',
      2: '课后作品',
      3: '自由创作'
    },
    iframeShowTools: false, // 针对JR,SC点击会展开虚拟手柄
  }),
  created() {
    // http://192.168.4.26:4003/MiniWorksDetails?name=%E5%B0%8F%E5%8D%ABsteam&pic=https%3A%2F%2Fsteamfun.oss-cn-zhangjiakou.aliyuncs.com%2Fstatic%2F22d534b5-414a-4f16-9ab2-e2d969e3442a%2F14912-00822bhDly1hr1a9ibrknj30sg0sg77d.jpg&worksType=afterClass&subjectCode=1&id=179713&stuId=151980&type=1
    /**
     * {
     *    name:'', // 名字
     *    pic:'', // 图片
     *    subjectCode?: '', // 查询科目 科目类型：1:Jrcode, 2:Scratch, 3:Python, 4:C++
     *    id:'', // 作品id
     *    stuId?:'', // 用户ID
     *    worksType:'', // 作品类型 afterClass:课后挑战 cpp:C++单独的 free:针对自由创作的 H5端判断调接口的
     *    type?:'', // 查询种类（1 上课创作，2 课后挑战，3 自由创作）对应小程序的tab标签
     * }
     */
    // 获取所有url参数
    this.pageUrlObj = getUrlArg();
    console.log('pageUrlObj:')
    console.log(this.pageUrlObj)
    // 获取作品类型
    const { worksType } = this.pageUrlObj;
    if (worksType === 'afterClass') {
      this.selectTchWorkDetail()
    } else if (worksType === 'cpp') {
      this.selectCppWorkDetail();
    } else if (worksType === 'free') {
      this.selectWorkDetail();
    }
    window.addEventListener('storage', this.handleStorageChange)
  },
  mounted() {
    // function updateIframeSrc() {
    //   console.log('触发了iframe的history')
    //   const iframe = document.getElementById('myIframe');
    //   const hash = window.location.hash.substring(1); // 获取 hash 值
    //   if (iframe && hash) {
    //     iframe.src = hash;
    //   }
    // }

    // window.addEventListener('hashchange', updateIframeSrc);

    // window.addEventListener('load', () => {
    //   updateIframeSrc(); // 初始加载时更新 iframe 源
    // });
  },
  methods: {
    // 课后挑战-详情
    selectTchWorkDetail() {
      api_selectTchWorkDetail({
        subjectCode: this.pageUrlObj.subjectCode, // 查询科目
        id: this.pageUrlObj.id, // 作品ID
        stuId: this.pageUrlObj.stuId, // 用户ID
        type: this.pageUrlObj.type, // 种类（1 上课创作 2课后挑战）
      }).then(res => {
        this.worksDetail = Object.assign(this.worksDetail, res)
        this.worksDetail.leave = this.worksDetail.markpoint
        /**
         *  id:'', // id
            createTime: '', // 时间
            title:'', // 作品名称
            introduce:'', // 介绍
            explain:'',// 操作说明
            iframeUrl: '', // iframe地址
            leave: '', // 作品等级
            remark: '', // 评语
            cppWorkDetailVoList: [], // c++题目组
         */
        this.selectH5()
      })
    },
    // 课后挑战-C++-详情
    selectCppWorkDetail() {
      api_selectCppWorkDetail({
        id: this.pageUrlObj.id, // 作品ID
        stuId: this.pageUrlObj.stuId, // 用户ID
        type: this.pageUrlObj.type, // 种类（1 上课创作 2课后挑战）
      }).then(res => {
        this.worksDetail = Object.assign(this.worksDetail, res)
        this.worksDetail.title = this.worksDetail.workTitle
        this.worksDetail.leave = this.worksDetail.markpoint
        if (res.cppWorkDetailVoList && res.cppWorkDetailVoList.join('') !== '') {
          res.cppWorkDetailVoList.forEach((codeItem, index) => {
            codeItem.id = codeItem.problemId
            codeItem.label = index + 1;
          })
          this.worksDetail.codeArr = res.cppWorkDetailVoList
          this.worksDetail.codes = res.cppWorkDetailVoList[0]
        }
      })
    },
    // 自由创作-详情
    selectWorkDetail() {
      api_selectWorkDetail({
        subjectCode: this.pageUrlObj.subjectCode, // 查询科目
        id: this.pageUrlObj.id, // 作品ID
        stuId: this.pageUrlObj.stuId, // 用户ID
      }).then(res => {
        this.worksDetail = Object.assign(this.worksDetail, res)
        this.selectH5()
      })
    },
    // H5信息查询
    selectH5() {
      api_selectH5({
        subjectCode: this.pageUrlObj.subjectCode, // 查询科目
        id: this.pageUrlObj.id, // 作品ID
        userId: this.pageUrlObj.stuId,
        workType: this.pageUrlObj.type, // 查询种类（1 上课创作，2 课后挑战，3 自由创作）
        userType: 1, // 用户类型（0用户，1学生用户） 目前是固定填1 2024-10-11
      }).then(res => {
        this.worksDetail = Object.assign(this.worksDetail, res)
        this.worksDetail.work_url = this.worksDetail.workUrl
        if (this.pageUrlObj.subjectCode === '3') {
          const codeArr = JSON.parse(this.worksDetail.workUrl)
          this.worksDetail.codes = codeArr[0]
          this.worksDetail.codeArr = codeArr
        }
        console.log(this.worksDetail)
      })
    },
    // 点击切换代码块
    handleChangeCodeItem(codeId) {
      this.worksDetail.codes = this.worksDetail.codeArr.find(item => item.id === codeId)
    },
    // 监听Storage设置高度
    handleStorageChange(event) {
      console.log(event, 'handleStorageChange')
      if (event.key == 'isShowType') {
        if (event.newValue == 'true') {
          this.iframeShowTools = true;
          console.log(123, 999);
          const oIframe = document.getElementById('bdIframe');
          console.log(oIframe, 123456);
          const deviceWidth = document.documentElement.clientWidth;
          // const deviceHeight = document.documentElement.clientHeight;
          // 计算小程序边框需要减去的宽度 40*2
          const miniDiffPadding = Number(deviceWidth) / 750 * 40 * 2
          oIframe.style.width = (Number(deviceWidth) - miniDiffPadding) + 'px'; //数字是页面布局宽度差值
          // oIframe.style.width = '100%'; //数字是页面布局宽度差值
          // oIframe.style.height = (Number(deviceHeight) - 515) + 'vw'; //数字是页面布局高度差
          // oIframe.style.height = (Number(deviceHeight) - 80) + 'px'; //数字是页面布局高度差
          oIframe.style.height = (Number(deviceWidth) * 1.55) + 'px'; //数字是页面布局高度差

          console.log(`打开手柄之后的宽高：width--${oIframe.style.width},height--${oIframe.style.height}`)

        } else {
          this.iframeShowTools = false;
          // this.frameWidth = document.documentElement.clientWidth * 1.06 - 30;
          // this.frameHeight = this.frameWidth * 0.75 + 55;

          console.log(456, 999);
          const oIframe = document.getElementById('bdIframe');
          console.log(oIframe, 123456);
          const deviceWidth = document.documentElement.clientWidth;
          // const deviceHeight = document.documentElement.clientHeight;
          // 计算小程序边框需要减去的宽度
          const miniDiffPadding = Number(deviceWidth) / 750 * 40 * 2
          oIframe.style.width = (Number(deviceWidth) - miniDiffPadding) + 'px'; //数字是页面布局宽度差值
          // oIframe.style.width = '100%'; //数字是页面布局宽度差值
          // oIframe.style.height = (Number(deviceHeight) - 335) + 'px'; //数字是页面布局高度差
          oIframe.style.height = (Number(deviceWidth) * 0.75 + 55) + 'px'; //数字是页面布局高度差

          console.log(`关闭手柄之后的宽高：width--${oIframe.style.width},height--${oIframe.style.height}`)
        }
      } else {
        if (event.newValue == 'true') {
          const oIframe = document.getElementById('scrrame');
          console.log(oIframe, 123456);
          const deviceWidth = document.documentElement.clientWidth;
          // const deviceHeight = document.documentElement.clientHeight;
          oIframe.style.width = (Number(deviceWidth) - 0) + 'px'; //数字是页面布局宽度差值
          // oIframe.style.height = (Number(deviceHeight) - 515) + 'vw'; //数字是页面布局高度差
          // oIframe.style.height = (Number(deviceHeight) - 80) + 'px'; //数字是页面布局高度差
          oIframe.style.height = (Number(deviceWidth) * 1.55) + 'px'; //数字是页面布局高度差
          console.log(oIframe.style.height, 123456);

        } else {
          // this.frameWidth = document.documentElement.clientWidth * 1.06 - 30;
          // this.frameHeight = this.frameWidth * 0.75 + 55;
          console.log(456, 999);
          const oIframe = document.getElementById('scrrame');
          console.log(oIframe, 123456);
          const deviceWidth = document.documentElement.clientWidth;
          // const deviceHeight = document.documentElement.clientHeight;
          oIframe.style.width = (Number(deviceWidth) - 0) + 'px'; //数字是页面布局宽度差值
          // oIframe.style.height = (Number(deviceHeight) - 335) + 'px'; //数字是页面布局高度差
          oIframe.style.height = (Number(deviceWidth) * 0.75 + 55) + 'px'; //数字是页面布局高度差
          console.log(oIframe.style.height, 123456);
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
  font-family: PingFangSC, PingFang SC;
}
.mini-page {
  width: 100vw;
  min-height: 100vh;
  max-width: 750px;
  padding: 40px;
  margin: auto;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  .user-info {
    padding-bottom: 20px;
    dl {
      display: grid;
      grid-template-columns: auto 1fr;
      dt {
        margin-right: 20px;
        img {
          width: 88px;
          height: 88px;
          border-radius: 50%;
        }
      }
      dd {
        display: grid;
        align-items: center;
        .name {
          font-size: 30px;
          color: #404653;
          line-height: 42px;
        }
        .before-time {
          font-size: 26px;
          color: #9fa3a9;
          line-height: 36px;
        }
      }
    }
  }
  .works-detail {
    .works-name {
      display: flex;
      align-items: center;
      padding-left: 15px;
      padding-bottom: 20px;
      span {
        font-size: 28px;
        color: #585d69;
      }
      h3 {
        font-size: 32px;
        color: #282f3e;
      }
    }
    .works-introduction,
    .works-OI,
    .leave,
    .remark {
      padding-bottom: 40px;
      strong {
        padding-bottom: 10px;
        font-size: 28px;
        color: #333333;
        line-height: 40px;
      }
      p {
        font-size: 28px;
        color: #585d69;
        line-height: 42px;
      }
    }
    .leave {
      display: grid;
      grid-template-columns: auto 1fr;
      align-items: center;
      strong {
        padding-right: 30px;
        padding-bottom: 0;
      }
      .el-rate /deep/ {
        height: auto;
        .el-rate__item {
          .el-rate__icon {
            font-size: 40px;
            margin-right: 10px;
          }
        }
      }
    }
    .works-window {
      .title {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 10px;
        img {
          flex-shrink: 0;
          width: 34px;
          margin-right: 10px;
          margin-bottom: 10px;
        }
        .title-name {
          padding-right: 15px;
          margin-bottom: 10px;
          font-size: 30px;
        }
        .el-tag {
          margin-right: 10px;
          margin-bottom: 10px;
          cursor: pointer;
        }
      }
      .iframe-box {
        width: calc(100vw - 80px);
        height: calc(100vw - 80px);
        min-height: calc(100vw - 80px);
        margin-bottom: 40px;
        border-radius: 15px;
        box-shadow: 0px 2px 4px 2px rgba(141, 141, 141, 0.5);
        //   background: palegreen;
        overflow: hidden;
        &.show-tools {
          height: auto;
        }
        .code-box {
          width: 100%;
          height: 100%;
          .vue-codemirror /deep/ {
            .CodeMirror {
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>